import PropTypes from 'prop-types'

import IconImageMultipleOutline from '@adv-mt/mt-svg-icons/lib/ImageMultipleOutline'
import IconVideoCameraOutline from '@adv-mt/mt-svg-icons/lib/VideocameraOutline'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Tag, TAG_DESIGNS, TAG_SIZES, TAG_USAGES} from '@adv-mt/ui/tag'

export const GALLERY_TAG_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video'
}

const ICONS = {
  [GALLERY_TAG_TYPES.IMAGE]: (
    <Icon size={ICON_SIZES.SM}>
      <IconImageMultipleOutline size={ICON_SIZES.SM} />
    </Icon>
  ),
  [GALLERY_TAG_TYPES.VIDEO]: (
    <Icon size={ICON_SIZES.SM}>
      <IconVideoCameraOutline size={ICON_SIZES.SM} />
    </Icon>
  )
}

const GalleryTag = ({type, negative, ...props}) => (
  <Tag
    usage={TAG_USAGES.ASSIST}
    design={TAG_DESIGNS.FLAT}
    size={TAG_SIZES.MEDIUM}
    iconLeft={type ? ICONS[type] : undefined}
    negative={negative}
    {...props}
  />
)

GalleryTag.displayName = 'GalleryTag'

GalleryTag.propTypes = {
  type: PropTypes.oneOf(Object.values(GALLERY_TAG_TYPES)),
  negative: PropTypes.bool
}

export default GalleryTag
